import { render } from "./delivery-from.vue?vue&type=template&id=50411827&scoped=true"
import script from "./delivery-from.vue?vue&type=script&lang=js"
export * from "./delivery-from.vue?vue&type=script&lang=js"

import "./delivery-from.vue?vue&type=style&index=0&id=50411827&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50411827"]])

export default __exports__